import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { JiraExtension } from '@atlassian/forge-ui-types';
import { createMakeProductURLPath } from '../createMakeProductURLPath';
import { ensurePropertyExists } from './common';
var makeJiraURLPath = createMakeProductURLPath('/jira');

// NOTE: Project Keys are always uppercase in Jira - the urls below will automatically convert any provided project key to uppercase
// https://confluence.atlassian.com/adminjiraserver/changing-the-project-key-format-938847081.html#:~:text=The%20project%20key%20only%20supports,lowercase%20characters%20to%20uppercase%20ones.

export var jiraExtensionURLHelpers = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, JiraExtension.ADMIN_PAGE, function (_ref) {
  var appId = _ref.appId,
    environmentId = _ref.environmentId;
  return makeJiraURLPath("/settings/apps/".concat(appId, "/").concat(environmentId));
}), JiraExtension.GLOBAL_PAGE, function (_ref2) {
  var appId = _ref2.appId,
    environmentId = _ref2.environmentId;
  return makeJiraURLPath("/apps/".concat(appId, "/").concat(environmentId));
}), JiraExtension.PERSONAL_SETTINGS_PAGE, function (_ref3) {
  var appId = _ref3.appId,
    environmentId = _ref3.environmentId;
  return makeJiraURLPath("/settings/personal/apps/".concat(appId, "/").concat(environmentId));
}), JiraExtension.PROJECT_SETTINGS_PAGE, function (_ref4, _ref5) {
  var appId = _ref4.appId,
    environmentId = _ref4.environmentId;
  var projectKey = _ref5.projectKey;
  return makeJiraURLPath("/software/projects/".concat(ensurePropertyExists('projectKey', projectKey).toUpperCase(), "/settings/apps/").concat(appId, "/").concat(environmentId));
}), JiraExtension.PROJECT_PAGE, function (_ref6, _ref7) {
  var appId = _ref6.appId,
    environmentId = _ref6.environmentId;
  var projectKey = _ref7.projectKey;
  return makeJiraURLPath("/software/projects/".concat(ensurePropertyExists('projectKey', projectKey).toUpperCase(), "/apps/").concat(appId, "/").concat(environmentId));
});
export var jiraNavigationTargetHandlers = {
  dashboard: function () {
    var _dashboard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref8) {
      var dashboardId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dashboardId = _ref8.dashboardId;
            return _context.abrupt("return", makeJiraURLPath("/dashboards/".concat(ensurePropertyExists('dashboardId', dashboardId))));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function dashboard(_x) {
      return _dashboard.apply(this, arguments);
    }
    return dashboard;
  }(),
  issue: function () {
    var _issue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref9) {
      var issueKey;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            issueKey = _ref9.issueKey;
            return _context2.abrupt("return", "/browse/".concat(ensurePropertyExists('issueKey', issueKey)));
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function issue(_x2) {
      return _issue.apply(this, arguments);
    }
    return issue;
  }(),
  // equivalent to Connects projectAdminSummary target
  projectSettingsDetails: function () {
    var _projectSettingsDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref10) {
      var projectKey;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            projectKey = _ref10.projectKey;
            return _context3.abrupt("return", makeJiraURLPath("/software/projects/".concat(ensurePropertyExists('projectKey', projectKey).toUpperCase(), "/settings/details")));
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function projectSettingsDetails(_x3) {
      return _projectSettingsDetails.apply(this, arguments);
    }
    return projectSettingsDetails;
  }()
};